// import { css } from '@emotion/css'
import styled from '@emotion/styled'
import Tabs from 'rc-tabs'

const StyledTab = styled(Tabs)`
  /* padding: 20px;
  font-size: 14px;
  overflow: hidden; */
  &.rc-tabs {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0;
  }
  .rc-tabs-nav {
    display: flex;
    flex: none;
    position: relative;
    height: 48px;
    font-size: 0.875rem;
    border-bottom: 1px solid #e7e7e7;
  }
  .rc-tabs-nav-measure,
  .rc-tabs-nav-wrap {
    height: 100%;
    transform: translate(0);
    position: relative;
    display: inline-block;
    flex: auto;
    white-space: nowrap;
    overflow: hidden;
    display: flex;
  }
  .rc-tabs-nav-measure-ping-left::before,
  .rc-tabs-nav-wrap-ping-left::before,
  .rc-tabs-nav-measure-ping-right::after,
  .rc-tabs-nav-wrap-ping-right::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
  }
  .rc-tabs-nav-measure-ping-left::before,
  .rc-tabs-nav-wrap-ping-left::before {
    left: 0;
    /* border-left: 1px solid red; */
    border-left: 1px solid rgba(0, 0, 0, 0.125);
  }
  .rc-tabs-nav-measure-ping-right::after,
  .rc-tabs-nav-wrap-ping-right::after {
    right: 0;
    /* border-right: 1px solid red; */
    border-right: 1px solid rgba(0, 0, 0, 0.125);
  }
  .rc-tabs-nav-measure-ping-top::before,
  .rc-tabs-nav-wrap-ping-top::before,
  .rc-tabs-nav-measure-ping-bottom::after,
  .rc-tabs-nav-wrap-ping-bottom::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
  }
  .rc-tabs-nav-measure-ping-top::before,
  .rc-tabs-nav-wrap-ping-top::before {
    top: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.125);
  }
  .rc-tabs-nav-measure-ping-bottom::after,
  .rc-tabs-nav-wrap-ping-bottom::after {
    bottom: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.125);
  }
  .rc-tabs-nav-list {
    display: flex;
    position: relative;
    transition: transform 0.3s;
  }
  .rc-tabs-nav-operations {
    display: flex;
  }
  .rc-tabs-nav-operations-hidden {
    position: absolute;
    visibility: hidden;
    pointer-events: none;
  }
  .rc-tabs-nav-more {
    display: inline-block;
    /* padding:0; */
    margin: 0 0.3rem 0 0.3rem;
    /* margin:0; */
    border-radius: 0.2rem;
    border: 1px solid rgba(0, 0, 0, 0.125);
    background: rgba(255, 0, 0, 0.02);
    cursor: pointer;
  }
  .rc-tabs-nav-add {
    border: 1px solid green;
    background: rgba(0, 255, 0, 0.1);
  }
  .rc-tabs-nav {
    /* border:1px solid pink; */
    border-bottom: 1px solid #eef0f2;
  }
  .rc-tabs-tab {
    border: 0;
    font-size: 20px;
    padding: 0 16px;
    background: rgba(255, 255, 255, 0.5);
    margin: 0;
    display: flex;
    outline: none;
    cursor: pointer;
    position: relative;
    font-weight: 400;
    align-items: center;
    color: rgba(0, 0, 0, 0.9);
    /* border:1px solid green; */
    /* margin:0.5rem  1.5em 1rem 0rem; */
  }
  .rc-tabs-tab-btn,
  .rc-tabs-tab-remove {
    border: 0;
    background: transparent;
  }
  .rc-tabs-tab-btn {
    font-size: 0.875rem;
    box-sizing: border-box;
    color: var(--text-gray-100);
    /* color:red; */
    position: relative;
    border: none;
    outline: none;
    display: inline-flex;
    align-items: center;
  }
  .rc-tabs-tab-btn:focus {
    color: var(--ow-color-primary-700);
  }
  .rc-tabs-tab-remove:hover {
    color: red;
  }
  .rc-tabs-tab-active {
    .rc-tabs-tab-btn {
      font-weight: bold;
      color: var(--ow-color-primary-700);
    }
  }
  .rc-tabs-ink-bar {
    position: absolute;
    bottom: -1px;
    background: var(--ow-color-primary-700);
    /* background:green; */
    /* border:1px solid pink; */
    padding: 0.1rem 0;
    /* margin-right:1.8rem; */
    pointer-events: none;
  }
  .rc-tabs-ink-bar-animated {
    transition: all 0.3s;
  }
  .rc-tabs-extra-content {
    font-size: 0.875rem;
    font-weight: 700;
    color: #444444;
    /* color:pink; */
    margin-top: 0.5rem;
    padding: 0 0.3rem;
  }
  .rc-tabs-content {
    overflow-y: scroll;
    /* padding: 20px 0 0 0; */
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.65;
    color: #444444;
    padding: 1rem;
    overflow: auto;
    height: calc(100% - 48px);
    /* color:red; */
  }
  .rc-tabs-dropdown {
    position: absolute;
    background: #fefefe;
    border: 1px solid rgba(0, 0, 0, 0.125);
    color: #526484;
    border-radius: 3px;
    max-height: 140px;
    overflow-y: scroll;
    cursor: pointer;
  }
  .rc-tabs-dropdown-hidden {
    display: none;
  }
  .rc-tabs-dropdown-menu {
    margin: 0;
    padding: 0;
    list-style: none;
  }
  .rc-tabs-dropdown-menu-item {
    padding: 4px 8px;
  }
  .rc-tabs-dropdown-menu-item-selected {
    background: green;
  }
  .rc-tabs-dropdown-menu-item-disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
  .rc-tabs-content {
    display: flex;
    width: 100%;
  }
  .rc-tabs-content-holder {
    flex: auto;
    height: 100%;
    overflow: auto;
  }
  .rc-tabs-content-animated {
    transition: margin 0.3s;
  }
  .rc-tabs-tabpane {
    width: 100%;
    height: 100%;
    flex: none;
  }
  .rc-tabs-top,
  .rc-tabs-bottom {
    flex-direction: column;
  }
  .rc-tabs-top .rc-tabs-ink-bar,
  .rc-tabs-bottom .rc-tabs-ink-bar {
    height: 1px;
  }
  .rc-tabs-top .rc-tabs-ink-bar {
    bottom: 0;
  }
  .rc-tabs-bottom .rc-tabs-nav {
    order: 1;
  }
  .rc-tabs-bottom .rc-tabs-content {
    order: 0;
  }
  .rc-tabs-bottom .rc-tabs-ink-bar {
    top: 0;
  }
  .rc-tabs-left.rc-tabs-editable .rc-tabs-tab,
  .rc-tabs-right.rc-tabs-editable .rc-tabs-tab {
    padding-right: 32px;
  }
  .rc-tabs-left .rc-tabs-nav-wrap,
  .rc-tabs-right .rc-tabs-nav-wrap {
    flex-direction: column;
  }
  .rc-tabs-left .rc-tabs-ink-bar,
  .rc-tabs-right .rc-tabs-ink-bar {
    width: 3px;
  }
  .rc-tabs-left .rc-tabs-nav,
  .rc-tabs-right .rc-tabs-nav {
    flex-direction: column;
    min-width: 50px;
  }
  .rc-tabs-left .rc-tabs-nav-list,
  .rc-tabs-right .rc-tabs-nav-list,
  .rc-tabs-left .rc-tabs-nav-operations,
  .rc-tabs-right .rc-tabs-nav-operations {
    flex: 1 0 auto;
    flex-direction: column;
  }
  .rc-tabs-left .rc-tabs-ink-bar {
    right: 0;
  }
  .rc-tabs-right .rc-tabs-nav {
    order: 1;
  }
  .rc-tabs-right .rc-tabs-content {
    order: 0;
  }
  .rc-tabs-right .rc-tabs-ink-bar {
    left: 0;
  }
  .rc-tabs-rtl {
    direction: rtl;
  }
  .rc-tabs-dropdown-rtl {
    direction: rtl;
  }
`
export default StyledTab
